/* tslint:disable */

declare var Object: any;
export interface TeomsurveyheaderInterface {
  "surveyCode": string;
  "companyCode": string;
  "surveyNameEn": string;
  "surveyNameId": string;
  "surveyNameMy": string;
  "surveyNameTh": string;
  "surveyType": string;
  "startDate"?: Date;
  "endDate"?: Date;
  "surveyDuration"?: number;
  "surveyAnonymous"?: string;
  "surveyStatus"?: number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "pollImage"?: string;
}

export class Teomsurveyheader implements TeomsurveyheaderInterface {
  "surveyCode": string;
  "companyCode": string;
  "surveyNameEn": string;
  "surveyNameId": string;
  "surveyNameMy": string;
  "surveyNameTh": string;
  "surveyType": string;
  "startDate": Date;
  "endDate": Date;
  "surveyDuration": number;
  "surveyAnonymous": string;
  "surveyStatus": number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "pollImage": string;
  constructor(data?: TeomsurveyheaderInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Teomsurveyheader`.
   */
  public static getModelName() {
    return "Teomsurveyheader";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Teomsurveyheader for dynamic purposes.
  **/
  public static factory(data: TeomsurveyheaderInterface): Teomsurveyheader{
    return new Teomsurveyheader(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Teomsurveyheader',
      plural: 'Teomsurveyheaders',
      path: 'Teomsurveyheaders',
      properties: {
        "surveyCode": {
          name: 'surveyCode',
          type: 'string'
        },
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "surveyNameEn": {
          name: 'surveyNameEn',
          type: 'string'
        },
        "surveyNameId": {
          name: 'surveyNameId',
          type: 'string'
        },
        "surveyNameMy": {
          name: 'surveyNameMy',
          type: 'string'
        },
        "surveyNameTh": {
          name: 'surveyNameTh',
          type: 'string'
        },
        "surveyType": {
          name: 'surveyType',
          type: 'string'
        },
        "startDate": {
          name: 'startDate',
          type: 'Date'
        },
        "endDate": {
          name: 'endDate',
          type: 'Date'
        },
        "surveyDuration": {
          name: 'surveyDuration',
          type: 'number'
        },
        "surveyAnonymous": {
          name: 'surveyAnonymous',
          type: 'string'
        },
        "surveyStatus": {
          name: 'surveyStatus',
          type: 'number'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "pollImage": {
          name: 'pollImage',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Teomsurveyheader.ts